// Demo data — parental leave, transfer consent, access logs, audit logs
// All real emails (swpark@tscientific.co.kr, jay.yu@tscientific.co.kr) replaced with generic placeholders.

export const PARENTAL_LEAVE_ALERTS = [
  {
    id: 2, employee_id: 'TS2600019', employee_name: '직원 O',
    leave_type: 'parental', leave_type_label: '육아휴직',
    end_date: new Date(Date.now() + 18 * 86400000).toISOString().slice(0, 10),
    days_until_return: 18, alert_level: 'medium',
    message: '직원 O 육아휴직 복귀 18일 전',
  },
];

export const PARENTAL_LEAVE_RECORDS = [
  {
    id: 1, employee_id: 'TS2600008', employee_name: '직원 H',
    leave_type: 'maternity', leave_type_label: '출산휴가',
    start_date: '2025-06-01', end_date: '2025-08-29', status: 'completed', status_label: '완료',
    child_birth_date: '2025-06-15', child_name: '자녀 1', notes: '정상 출산',
    created_at: Date.now() / 1000 - 200 * 86400,
  },
  {
    id: 2, employee_id: 'TS2600019', employee_name: '직원 O',
    leave_type: 'parental', leave_type_label: '육아휴직',
    start_date: '2025-09-01', end_date: new Date(Date.now() + 18 * 86400000).toISOString().slice(0, 10),
    status: 'active', status_label: '사용중',
    child_birth_date: '2025-05-20', child_name: '자녀 2', notes: null,
    created_at: Date.now() / 1000 - 150 * 86400,
  },
  {
    id: 3, employee_id: 'TS2600015', employee_name: '직원 P',
    leave_type: 'paternity', leave_type_label: '배우자출산휴가',
    start_date: '2025-10-01', end_date: '2025-10-10', status: 'completed', status_label: '완료',
    child_birth_date: '2025-09-28', child_name: '자녀 3', notes: null,
    created_at: Date.now() / 1000 - 100 * 86400,
  },
  {
    id: 4, employee_id: 'TS2600008', employee_name: '직원 H',
    leave_type: 'childcare_reduction', leave_type_label: '육아기근로시간단축',
    start_date: '2026-03-01', end_date: '2026-08-31', status: 'planned', status_label: '예정',
    child_birth_date: '2025-06-15', child_name: '자녀 1', notes: '주 25시간 근무',
    created_at: Date.now() / 1000 - 10 * 86400,
  },
];

export const TRANSFER_CONSENT_RECORDS = [
  {
    id: 1, employee_id: 'TS2600003', employee_name: '직원 C',
    transfer_type: 'transfer', transfer_type_label: '전보',
    from_value: '영업팀', to_value: '연구개발팀',
    reason: '프로젝트 수요 증가에 따른 인력 재배치',
    consent_status: 'agreed', consent_status_label: '동의',
    consent_date: '2026-01-15', effective_date: '2026-02-01',
    notes: '본인 희망 전보', created_at: Date.now() / 1000 - 30 * 86400,
  },
  {
    id: 2, employee_id: 'TS2600012', employee_name: '직원 L',
    transfer_type: 'role_change', transfer_type_label: '직무변경',
    from_value: '품질검사 담당', to_value: '품질관리 책임자',
    reason: '직무 역량 강화 및 승진 연계',
    consent_status: 'pending', consent_status_label: '대기중',
    consent_date: null, effective_date: '2026-03-01',
    notes: null, created_at: Date.now() / 1000 - 5 * 86400,
  },
  {
    id: 3, employee_id: 'TS2600021', employee_name: '직원 U',
    transfer_type: 'secondment', transfer_type_label: '파견',
    from_value: '품질관리팀', to_value: '협력사 A (6개월)',
    reason: '품질 관리 기술 이전',
    consent_status: 'agreed', consent_status_label: '동의',
    consent_date: '2025-12-20', effective_date: '2026-01-10',
    notes: '파견 수당 별도 지급', created_at: Date.now() / 1000 - 50 * 86400,
  },
];

// Access logs — usernames are generic system account labels, no real names
export const ACCESS_LOG_SUMMARY = {
  today_count: 5,
  week_count: 18,
  month_count: 47,
  total_count: 312,
  unique_users: 4,
  top_users: [
    { username: 'admin', count: 22 },
    { username: 'hr_manager', count: 15 },
    { username: 'team_leader_01', count: 7 },
    { username: 'team_leader_02', count: 3 },
  ],
  by_resource_type: { '직원 상세정보': 28, '급여 정보': 9, '평가 결과': 6, '근로계약 정보': 4 },
  by_action: { '조회': 39, '수정': 5, '다운로드/내보내기': 3 },
  retention_days: 180,
  oldest_log_date: '2025-08-15',
};

export const ACCESS_LOGS = [
  { id: 1, username: 'admin', action: 'view', action_label: '조회', resource_type: 'employee_detail', resource_type_label: '직원 상세정보', resource_id: 'TS2600001', ip_address: '192.168.1.10', created_at: Date.now() / 1000 - 300 },
  { id: 2, username: 'hr_manager', action: 'view', action_label: '조회', resource_type: 'salary_info', resource_type_label: '급여 정보', resource_id: 'TS2600005', ip_address: '192.168.1.20', created_at: Date.now() / 1000 - 1200 },
  { id: 3, username: 'admin', action: 'export', action_label: '다운로드/내보내기', resource_type: 'employee_detail', resource_type_label: '직원 상세정보', resource_id: 'TS2600010', ip_address: '192.168.1.10', created_at: Date.now() / 1000 - 3600 },
  { id: 4, username: 'team_leader_01', action: 'view', action_label: '조회', resource_type: 'evaluation_result', resource_type_label: '평가 결과', resource_id: 'TS2600003', ip_address: '192.168.1.30', created_at: Date.now() / 1000 - 7200 },
  { id: 5, username: 'admin', action: 'edit', action_label: '수정', resource_type: 'personnel_record', resource_type_label: '인사기록', resource_id: 'TS2600012', ip_address: '192.168.1.10', created_at: Date.now() / 1000 - 14400 },
  { id: 6, username: 'hr_manager', action: 'view', action_label: '조회', resource_type: 'contract_info', resource_type_label: '근로계약 정보', resource_id: 'TS2600020', ip_address: '192.168.1.20', created_at: Date.now() / 1000 - 28800 },
  { id: 7, username: 'admin', action: 'view', action_label: '조회', resource_type: 'training_record', resource_type_label: '교육 이력', resource_id: 'TS2600007', ip_address: '192.168.1.10', created_at: Date.now() / 1000 - 43200 },
  { id: 8, username: 'hr_manager', action: 'view', action_label: '조회', resource_type: 'employee_detail', resource_type_label: '직원 상세정보', resource_id: 'TS2600015', ip_address: '192.168.1.20', created_at: Date.now() / 1000 - 86400 },
  { id: 9, username: 'admin', action: 'export', action_label: '다운로드/내보내기', resource_type: 'salary_info', resource_type_label: '급여 정보', resource_id: 'ALL', ip_address: '192.168.1.10', created_at: Date.now() / 1000 - 172800 },
  { id: 10, username: 'team_leader_02', action: 'view', action_label: '조회', resource_type: 'evaluation_result', resource_type_label: '평가 결과', resource_id: 'TS2600025', ip_address: '192.168.1.35', created_at: Date.now() / 1000 - 259200 },
];

// Audit logs — real email addresses removed, replaced with generic system account usernames
export const AUDIT_SUMMARY = {
  today_count: 45, week_count: 234, month_count: 891, total_count: 4523,
  unique_users: 8, login_failures_today: 1,
  by_action: { '로그인': 320, '조회': 210, '수정': 85, '다운로드': 42, '생성': 31, '삭제': 5 },
  by_resource_type: { '직원': 310, '인사평가': 89, '리포트': 42, '시스템': 320, '조직': 25 },
  top_users: [
    { username: 'user_a', count: 156 },
    { username: 'user_b', count: 132 },
    { username: 'user_c', count: 98 },
  ],
};

export const AUDIT_LOGS = [
  { id: 1, username: 'user_a', action: 'login', action_label: '로그인', resource_type: 'system', resource_type_label: '시스템', resource_id: null, details: null, old_value: null, new_value: null, ip_address: '10.0.1.5', created_at: Date.now() / 1000, created_at_formatted: '2026-02-10 09:05:12' },
  { id: 2, username: 'user_b', action: 'read', action_label: '조회', resource_type: 'employee', resource_type_label: '직원', resource_id: 'TS2600003', details: null, old_value: null, new_value: null, ip_address: '10.0.1.8', created_at: Date.now() / 1000 - 600, created_at_formatted: '2026-02-10 08:55:03' },
  { id: 3, username: 'user_a', action: 'export', action_label: '다운로드', resource_type: 'report', resource_type_label: '리포트', resource_id: 'employee_roster', details: '리포트 다운로드 (excel)', old_value: null, new_value: null, ip_address: '10.0.1.5', created_at: Date.now() / 1000 - 1200, created_at_formatted: '2026-02-10 08:45:21' },
];

export const AUDIT_TRAIL = [
  { id: 1, action: 'read', resource_type: 'employee', resource_id: 'TS2600001', username: 'user_a@example.com', timestamp: '2026-02-14T10:30:00', details: '직원 상세 조회' },
  { id: 2, action: 'update', resource_type: 'employee', resource_id: 'TS2600005', username: 'user_b@example.com', timestamp: '2026-02-14T09:15:00', details: '직급 변경' },
  { id: 3, action: 'export', resource_type: 'report', resource_id: 'team_headcount', username: 'user_a@example.com', timestamp: '2026-02-13T16:00:00', details: '팀별 인원 현황 리포트 다운로드' },
];
